export default class PairWith {
  constructor(partnerType, stratumMin, stratumMax) {
    this.partnerType = partnerType;
    this.strata = {};
    this.strata.min = stratumMin;
    this.strata.max = stratumMax;
  }
}
